function DeviceCluster() {
    "use strict";

    this.__type = 'DeviceCluster:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Description = '';
    this.IsActive = true;
    this.Name = '';
    this.OrganizationId = '';
    this.ZoneId = -1;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceCluster;
}